import type { IGallerySection, IMetaData, ISection } from '@features/productPreview/typescript';
const DIMENSIONS_IMAGE_PATTERN = /\/file\/product\/main\//i;
const isDimensionsImage = (url: string): boolean => DIMENSIONS_IMAGE_PATTERN.test(url);
const getPresetsImage = (presetsImages: IMetaData['presetsImages']): string | null => {
  if (Array.isArray(presetsImages) && presetsImages.length > 0) {
    return presetsImages[0] ?? null;
  }
  if (presetsImages && typeof presetsImages === 'object') {
    const values = Object.values(presetsImages).filter(Boolean);
    return values[0] ?? null;
  }
  return null;
};
const getGalleryPackshot = (sections?: ISection[]): string | null => {
  if (!Array.isArray(sections)) return null;
  const productSlides = sections.find(section => section.type === 'PRODUCT_SLIDES') as IGallerySection | undefined;
  if (!productSlides?.items?.[0]?.slides?.[0]) return null;
  const firstSlide = productSlides.items[0].slides[0];
  return firstSlide.image?.desktop || firstSlide.desktop || null;
};
const getProductShareImage = (metaData: IMetaData, sections?: ISection[]): string => {
  const presetsImage = getPresetsImage(metaData.presetsImages);
  if (presetsImage) return presetsImage;
  const galleryImage = getGalleryPackshot(sections);
  if (galleryImage) return galleryImage;
  if (metaData.image && !isDimensionsImage(metaData.image)) {
    return metaData.image;
  }
  return metaData.image || '';
};
export default getProductShareImage;